import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    viewBox={'0 0 24 24'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#000'}
      d="m17.1 19.15-2.3 2.325c-.15.15-.325.225-.525.225s-.375-.075-.525-.225a.734.734 0 0 1-.225-.538c0-.208.075-.387.225-.537l2.3-2.3-2.325-2.3a.72.72 0 0 1-.225-.525c0-.2.075-.375.225-.525.15-.15.33-.225.538-.225.208 0 .387.075.537.225l2.3 2.3 2.3-2.325c.15-.15.325-.225.525-.225s.375.075.525.225c.15.15.225.33.225.537a.734.734 0 0 1-.225.538l-2.3 2.3 2.325 2.3c.15.15.225.325.225.525s-.075.375-.225.525a.734.734 0 0 1-.538.225.734.734 0 0 1-.537-.225l-2.3-2.3Zm-13.35-3.4a.723.723 0 0 1-.534-.217.732.732 0 0 1-.216-.537.73.73 0 0 1 .75-.745h6c.212-.001.39.071.534.216a.732.732 0 0 1 .216.537.732.732 0 0 1-.75.745h-6Zm0-4.125a.723.723 0 0 1-.534-.217.732.732 0 0 1-.216-.537.73.73 0 0 1 .75-.745H14c.212-.001.39.071.534.216a.732.732 0 0 1 .216.537.732.732 0 0 1-.75.745H3.75Zm0-4.125a.723.723 0 0 1-.534-.217A.732.732 0 0 1 3 6.745.73.73 0 0 1 3.75 6H14c.212 0 .39.072.534.217a.732.732 0 0 1 .216.537.732.732 0 0 1-.75.746H3.75Z"
    />
  </Svg>
);
export default SvgComponent;
